import { CustomMappingType } from '@principle-theorem/practice-migrations/interfaces';
import { CustomMapping } from '../../../custom-mapping';
import {
  BaseTransactionTypeMappingHandler,
  IBaseMigrationPaymentTypeSource,
  TRANSACTION_TYPE_CUSTOM_MAPPING_TYPE,
} from '../../../mappings/base-transaction-type';
import { IPracticeWorksItemCode } from '../../source/entities/ada-item';
import {
  PracticeWorksTransactionItemCode,
  UsedItemCodeTransactionSourceEntity,
} from '../../source/entities/used-item-code-transactions';

export const PAYMENT_TYPE_MAPPING = CustomMapping.init({
  metadata: {
    label: 'Item Code to Transaction Type Mapping',
    description: `Used to map PracticeWorks Payment Types to Principle Transaction Types. Any unmapped payment types will be assigned to a Manual Transaction type.`,
    type: TRANSACTION_TYPE_CUSTOM_MAPPING_TYPE,
  },
  type: CustomMappingType.SelectionList,
  labelOverrides: {
    sourceIdentifier: 'Id',
    sourceLabel: 'Non-ADA Code',
    destinationIdentifier: 'Map To',
    associatedValue: 'Transaction Type',
  },
});

export class PracticeWorksItemCodeToTransactionTypeMappingHandler extends BaseTransactionTypeMappingHandler<
  PracticeWorksTransactionItemCode,
  UsedItemCodeTransactionSourceEntity
> {
  override customMapping = PAYMENT_TYPE_MAPPING;
  override sourceEntity = new UsedItemCodeTransactionSourceEntity();

  translateFn = (
    record: IPracticeWorksItemCode
  ): IBaseMigrationPaymentTypeSource => {
    return {
      id: record.id.toString(),
      name: `${record.itemCode} - ${record.description}`,
    };
  };
}
